/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Document_Source_PdfInputs */

const en_orders_document_source_pdf = /** @type {(inputs: Orders_Document_Source_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF`)
};

const es_orders_document_source_pdf = /** @type {(inputs: Orders_Document_Source_PdfInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PDF`)
};

/**
* | output |
* | --- |
* | "PDF" |
*
* @param {Orders_Document_Source_PdfInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_document_source_pdf = /** @type {((inputs?: Orders_Document_Source_PdfInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Document_Source_PdfInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_document_source_pdf(inputs)
	return es_orders_document_source_pdf(inputs)
});